import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isSingleLineListView } from 'owa-mail-layout';
import isSenderImageEnabled from 'owa-messagelist-layout-option/lib/utils/isSenderImageEnabled';
import shouldHideMessageListCheckBoxes from 'owa-messagelist-layout-option/lib/utils/shouldHideMessageListCheckBoxes';

export default function showPersonaCheckbox(
    isSearchTable: boolean,
    tableView: TableView | undefined
): boolean {
    // Always show the checkbox in search table
    if (isSearchTable) {
        return true;
    }

    const senderImageEnabled = isSenderImageEnabled();

    // If the reselect flight is enabled show the checkbox if sender images are enabled
    // Do not show the checkbox if we are optimistically in checked mode
    if (isGlobalFeatureEnabled('tri-reselect-checkbox-behavior')) {
        if (senderImageEnabled) {
            return true;
        } else {
            return !!tableView?.isInCheckedMode && !tableView?.isOnlyOptimisticallyInCheckedMode;
        }
    }

    // With the new ML checkbox behavior flight, the legacy MailListSelectAllSLV
    // (which used to set isInSelectAllState = true in SLV via its mount effect) is
    // no longer rendered when sender images are off. Fall back to
    // isSingleLineListView() so row checkboxes still render in SLV in that case.
    if (shouldHideMessageListCheckBoxes()) {
        return isSingleLineListView() || !!tableView?.isInCheckedMode;
    }

    // Otherwise show the checkbox if sender images are enabled, we are in select all state, or in checked mode
    return senderImageEnabled || !!tableView?.isInSelectAllState || !!tableView?.isInCheckedMode;
}
